import { formatClock } from '../lib/format';
import { useApp } from '../state/AppState';
import { relayPhaseIsRetryable, relayStatusView, type RelayTone } from '../lib/live/status';

const TONE_CLASS: Record<RelayTone, string> = {
  ok: 'border-emerald-400/30 bg-emerald-400/10 text-emerald-200',
  busy: 'border-indigo-400/30 bg-indigo-400/10 text-indigo-200',
  warn: 'border-amber-400/30 bg-amber-400/10 text-amber-200',
  danger: 'border-rose-400/30 bg-rose-400/10 text-rose-200',
  idle: 'border-slate-600/40 bg-slate-500/10 text-slate-300',
};

export function StatusBanner() {
  const { network, paired, settings, relayPlan, relayKeyReady, retryRelay } = useApp();
  // Copy is recomputed from config + socket state, so a stale “未就绪” line can
  // never survive a successful reconnect (“未配置” / “连接中” / “已连接” stay
  // distinguishable).
  const relay = relayStatusView({
    demoMode: settings.demoMode,
    paired: Boolean(paired),
    plan: relayPlan,
    relayConnected: network.relayConnected,
    ...(network.relayStatus ? { relayStatus: network.relayStatus } : {}),
    keyReady: relayKeyReady,
  });
  return (
    <div className="flex flex-wrap items-center gap-2 px-4 pb-2 text-[11px] text-slate-400">
      <span
        className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 ${
          network.online
            ? 'border-emerald-400/30 bg-emerald-400/10 text-emerald-200'
            : 'border-amber-400/30 bg-amber-400/10 text-amber-200'
        }`}
      >
        <span
          className={`h-1.5 w-1.5 rounded-full ${network.online ? 'bg-emerald-400' : 'bg-amber-400'}`}
        />
        {network.online ? '在线' : '离线'}
      </span>
      <span
        className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 ${
          TONE_CLASS[relay.tone]
        }`}
      >
        {relay.label}
      </span>
      {relayPhaseIsRetryable(relay.phase) ? (
        <button
          type="button"
          onClick={retryRelay}
          className="rounded-full border border-white/10 bg-white/5 px-2 py-0.5 text-slate-200"
        >
          重试连接
        </button>
      ) : null}
      {settings.demoMode ? (
        <span className="rounded-full border border-sky-400/30 bg-sky-400/10 px-2 py-0.5 text-sky-200">
          MOCK 数据，不执行真实操作
        </span>
      ) : relayPlan.enabled ? (
        <span className="rounded-full border border-indigo-400/30 bg-indigo-400/10 px-2 py-0.5 text-indigo-200">
          E2E 中继（审批/聊天/执行）
        </span>
      ) : relayPlan.configured && !relayPlan.secure ? (
        <span className="rounded-full border border-amber-400/30 bg-amber-400/10 px-2 py-0.5 text-amber-200">
          HTTP 不安全：E2E 不可用
        </span>
      ) : null}
      {paired ? null : (
        <span className="rounded-full border border-rose-400/30 bg-rose-400/10 px-2 py-0.5 text-rose-200">
          未配对
        </span>
      )}
      {network.lastSyncAt ? <span>数据截至 {formatClock(network.lastSyncAt)}</span> : null}
      {network.relayDetail ? <span className="text-slate-500">{network.relayDetail}</span> : null}
      {network.detail ? <span className="text-slate-500">{network.detail}</span> : null}
    </div>
  );
}
